import { apiV2SegmentsApi } from '@app/core/hooks/api/api-v2-segments-api';
import chunk from 'lodash/chunk';
import { useEffect, useState } from 'react';
import { toTimestamp } from '@mi-front/core';
import { useActiveStation } from '../../../../../../../core/stations/hooks/useActiveStation';
import { useStreamSegmentsRange } from '../../../hooks/segments/useStreamSegmentsQuery';

/**
 * Pre-fetches segment audio to populate browser HTTP cache.
 * The browser will automatically cache responses based on Cache-Control headers.
 */
export function useCacheSegmentsAudio() {
  const station = useActiveStation();
  const streamRange = useStreamSegmentsRange();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const getSegmentsAudio = async () => {
      try {
        const sequence = await apiV2SegmentsApi.fetchSequence(
          station.id,
          toTimestamp(streamRange.from),
        );

        const totalSegments = sequence.length;
        let segmentsDownloaded = 0;
        const chunkedSequence = chunk(sequence, 4);

        await chunkedSequence.reduce(async (previousPromise, segmentChunk) => {
          await previousPromise;

          await Promise.all(
            segmentChunk.map(async (segment) => {
              try {
                await apiV2SegmentsApi.fetchSegmentAudio(station.id, segment.id);
              } catch (error) {
                console.error(`Error fetching audio for segment ${segment.id}:`, error);
              } finally {
                segmentsDownloaded++;
                const newProgress = Math.floor((segmentsDownloaded / totalSegments) * 100);
                setProgress(newProgress);
              }
            }),
          );

          await new Promise((resolve) => setTimeout(resolve, 4));
        }, Promise.resolve());
      } catch (error) {
        console.error('Error fetching segment sequence:', error);
      }
    };

    getSegmentsAudio();
  }, [station.id, streamRange]);

  return {
    progress,
  };
}
